<template>
    <div class="hello">
        <table border strip class="info-table">
            <tr>
                <th>序号</th>
                <th>字段名称</th>
                <th>修改前</th>
                <th>修改后</th>
                <th>修改人</th>
                <th>修改时间</th>
            </tr>
            <tr v-for="(a, i) in changeHistorys" :key="i">
                <td>{{i+1}}</td>
                <td>{{a.fchangeitem}}</td>
                <td>{{a.foldval}}</td>
                <td>{{a.fnewval}}</td>
                <td>{{a.ffchangeuserid}}</td>
                <td>{{a.createDate}}</td>
            </tr>
            <tr v-if="!changeHistorys.length"><td colspan=10>暂无数据</td></tr>
        </table>
        <el-pagination
            @current-change="handleCurrentChange"
            :page-size="10"
            :current-page="pager.pageNum"
            :total="pager.total"
            prev-text="上一页"
            next-text="下一页"
            layout="total, prev, pager, next"
            background
        >
        </el-pagination>
    </div>
</template>

<script type="text/babel">

    export default {
        name: 'supplier-changehistory',
        data () {
            return {
                changeHistorys: [],
                pager:{
                    total: 0,
                    pageNum: 1,
                    pageSize: 10
                }
            }
        },

        methods: {
            getChangHistory(){
                this.$http.post('/rest/api/completeFourInfo/getMainChanges',
                    Object.assign({
                            pageNum: this.pager.pageNum,
                            pageSize: this.pager.pageSize
                        }, {
                            stockId:  this.$root.stockId
                        }

                    )
                ).then((res)=>{
                    if(res.data.result) {
                        this.changeHistorys = res.data.value.list;
                        this.pager.total = res.data.value.count;
                        this.pager.pageNum = res.data.value.pageNo;
                    }
                    this.$root.loading = false;
                })
            },
            handleCurrentChange (page) {
                this.pager.pageNum = page;
                this.getChangHistory();
            }
        },

        created(){
            this.$root.loading = true
            this.getChangHistory();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/dsp/supplier/ChangeHistory.vue